import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { getProfile, User } from 'lib/personalization/profile';

/**
 * Support for shared header on PORTAL.
 *
 * @author Nikola Tica
 * @class SharedHeader
 * @extends Tc.Module
 */
export default class SharedHeader extends Module {
	private $scsHeader! : JQuery;

	public on(callback : Hook) {
		this.$scsHeader = this.$ctx.find('scs-header');

		this.$scsHeader.on('languageChanged', evt => {
			const url = this.$ctx.data('language-links')[`${evt.detail}`];
			location.assign(url);
		});

		callback();
	}

	public async after() {
		const user = (await getProfile()).getUser();
		this.initHeaderAttributes(user);
	}

	private initHeaderAttributes(user? : User) {
		if(user) {
			this.$scsHeader.attr('customer-segment', user.getSegment());
			this.$scsHeader.attr('user-lastname', user.getLastName());
			this.$scsHeader.attr('user-firstname', user.getFirstName());
			this.$scsHeader.attr('scn', user.getId());
		}
		const $lvl1 = this.$scsHeader.find('scs-header-l1');
		// Prevent shared header to display login button until user data are fetch
		$lvl1.attr('show-login', String(!!this.$ctx.data('showLogin')));
		// Allow the shared header to initialize its basket only after we have set the user’s SCN (if any)
		// Avoids querying the basket API twice
		$lvl1.attr('show-basket', String(!!this.$ctx.data('showBasket')));
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/header/Tc.Module.SharedHeader.ts